import { css } from 'linaria';

export const container = css`
  display: flex;
  flex-direction: column;
`;

export const labelWrapper = css`
  display: flex;
  margin-bottom: var(--space-50);
  gap: var(--space-100);
`;

export const iconButtonStyle = css`
  margin-left: auto;
  cursor: pointer;
`;

export const divider = css`
  margin: var(--space-250) 0;
`;
export const merchantInfoHeading = css`
  margin-bottom: var(--space-100);
`;

export const modalContent = css`
  p {
    display: block;
  }
`;

export const skeleton = css`
  margin-bottom: var(--space-75);
  border-radius: var(--rounding-m);
`;

export const skeletonShort = css`
  max-width: 90%;
`;

export const onlineOrderOnlyMessageTextStyle = css`
  margin: auto 0;
`;
